var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 12,
    viewBox: "0 0 10.5 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6115",
    "data-name": "Group 6115",
    transform: "translate(-41.5 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-copy",
    "data-name": "Icon awesome-copy",
    d: "M7.5,10.5v.938A.562.562,0,0,1,6.937,12H.562A.562.562,0,0,1,0,11.437V2.812A.562.562,0,0,1,.562,2.25H2.25V9.187A1.314,1.314,0,0,0,3.562,10.5Zm0-8.062V0H3.562A.562.562,0,0,0,3,.562V9.187a.562.562,0,0,0,.562.563H9.937a.562.562,0,0,0,.562-.562V3H8.062A.564.564,0,0,1,7.5,2.437Zm2.835-.727L8.79.165A.563.563,0,0,0,8.392,0H8.25V2.25H10.5V2.108a.562.562,0,0,0-.165-.4Z",
    transform: "translate(41.5 6)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copyWhite.9360045987b1275d2f4ab71abd599322.svg";
export { ForwardRef as ReactComponent };